module.exports = __webpack_public_path__ + "img/thumb-009-05.57f9d8eb.png";